module.exports = __webpack_public_path__ + "static/media/laurel_bronze_with_background.e5c29e77.svg";